import { Record } from 'immutable';
const defaultValues = {
  globalCookieOptOut: '',
  isFirstVisitorSession: true
};
export default Record(defaultValues, 'VisitorIdentity');